import React from "react";
import moment from "moment";
import { statusTone } from "./dispatchRules";
import { ActivityCell, StatusChip } from "./DispatchGrid";
import RideActions from "./RideActions";

const time = (value) => (value ? moment(value).format("DD/MM HH:mm") : "—");

/** One ride as a card (phones / small tablets): status, crew, route, times, vehicle and the actions as touch buttons. */
export default function DispatchCard({ ride, onTrack, onReplay, onMobile }) {
  return (
    <article className={`dsp-card is-${statusTone(ride)}`} aria-label={`Ride ${ride.rideId}`}>
      <header className="dsp-card__head">
        <span className="dsp-card__id">#{ride.rideId}</span>
        <span className="dsp-card__duty">{ride.activityType}</span>
        <StatusChip ride={ride} />
      </header>
      <div className="dsp-card__crew">
        <strong>{ride.paxName || "—"}</strong>
        <span>
          {ride.employeeNo}
          {ride.crewRank ? ` · ${ride.crewRank}` : ""}
        </span>
        {ride.paxMobileNo && (
          <a href={`tel:${ride.paxMobileNo}`} className="dsp-card__phone">
            <i className="fas fa-phone" aria-hidden="true" /> {ride.paxMobileNo}
          </a>
        )}
      </div>
      <ol className="dsp-card__route">
        <li>
          <i className="fas fa-circle" aria-hidden="true" /> {ride.pickupLocation || "—"}
        </li>
        <li>
          <i className="fas fa-map-marker-alt" aria-hidden="true" /> {ride.dropoffLocation || "—"}
        </li>
      </ol>
      <dl className="dsp-card__facts">
        <div>
          <dt>Pickup</dt>
          <dd>{time(ride.pickupTime)}</dd>
        </div>
        <div>
          <dt>Reporting</dt>
          <dd>{time(ride.dutyReportingTime)}</dd>
        </div>
        <div>
          <dt>Activity</dt>
          <dd>
            <ActivityCell ride={ride} />
          </dd>
        </div>
        <div>
          <dt>Vehicle</dt>
          <dd>{[ride.vehicleNo, ride.driverName].filter(Boolean).join(" · ") || "—"}</dd>
        </div>
        <div className="dsp-card__wide">
          <dt>Service provider</dt>
          <dd>{ride.transporterName || "—"}</dd>
        </div>
      </dl>
      <footer className="dsp-card__foot">
        <RideActions ride={ride} onTrack={onTrack} onReplay={onReplay} onMobile={onMobile} large />
      </footer>
    </article>
  );
}
